import React, {useEffect} from 'react';
import './styles.scss';
import GridPage from "../../grids/gridPage";

const MyReports = ({history}) => {

    // Убираем очистку при загрузке страницы - пусть работает только ограничение в 10 записей

    const canEditByRow = (col, row) => {
        if (col.fieldName === "actualDepartureDate"
            || col.fieldName === "actualDeliveryDate"
            || col.fieldName === "actualWeight")
        {
            return row.statusCode === 'Shipped'
                || row.statusCode === 'Delivered'
                || row.statusCode === 'Completed';
        }

        const arrayOfColNames = [
            "awardAgent",
            "costPrice",
            "actualCostPrice",
            "profitPooling",
            "deliveryCost",
            "createByManagerCost",
            "discountForCustomer",
            "insuranceCost",
            "actualCostForAgent",
            "actualDeliveryCost",
            "deliveryDate"
        ];

        const arrayOfStatuses = [
            'Invoicing',
            'InvoicePaid',
            'InvoiceIssued'
        ]

        return !(arrayOfColNames.includes(col.fieldName) && arrayOfStatuses.includes(row.statusCode));
    }

    return (
        <div>
            <GridPage
                history={history}
                gridName={'parcels'}
                label={'Мои отчеты'}
                canEditByRow={canEditByRow}
                preFilters={{}}
            />
        </div>
    );
};

export default MyReports;


// WEBPACK FOOTER //
// ./App/pages/reports/myReports.jsx